module.exports = __webpack_public_path__ + "img/bird-window-2.e188d816.png";